import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerBowerProps = {
  component: object;
  range: object;
  safeVersion?: string;
  unsafeVersion?: object;
  transitive?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerBower: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerBowerProps
> = props => {
  let component = props.component,
    range = props.range,
    name = component.name,
    safeVersion = props.safeVersion,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    transitive = props.transitive == undefined ? false : props.transitive;
  if (!transitive) {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="bower.json" />
        <ArtifactViewCodeDiffDisplay type="normal" text='"dependencies": {' />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={'\u2003\u0022' + name + '\u0022: \u0022' + unsafeVersion + '\u0022,'}
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'\u2003\u0022' + name + '\u0022: \u0022' + safeVersion + '\u0022,'}
        />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="normal" text="}" />
      </div>
    );
  } else {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="bower.json" />
        <ArtifactViewCodeDiffDisplay type="add" text='"dependencies": {' />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'\u2003\u0022' + name + '\u0022: \u0022' + safeVersion + '\u0022,'}
        />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="add" text="}," />
        <ArtifactViewCodeDiffDisplay type="add" text='"resolutions": {' />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'\u2003\u0022' + name + '\u0022: \u0022' + safeVersion + '\u0022,'}
        />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="add" text="}" />
      </div>
    );
  }
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerBower;
